import { HeadCell } from '../components/tables/BakeasyTable';

export const messageTableHeaders: HeadCell[] = [
  { id: 'messageDateTime', label: 'DATE_MM_DD_YYYY', width: '120px' },
  { id: 'from', label: 'FROM' },
  { id: 'to', label: 'TO', width: '180px' },
  { id: 'priority', label: 'PRIORITY' },
  { id: 'subject', label: 'SUBJECT', width: '200px' },
  { id: 'recsent', label: 'STATUS' },
  { id: 'content', label: 'CONTENT', width: '200px' },
  { id: 'actions', label: 'ACTIONS' }
];

export const supplierTableHeaders: HeadCell[] = [
  { id: 'supplierNumber', label: 'SUPPLIER_ID', sort: true },
  { id: 'supplierName', label: 'SUPPLIER_NAME', sort: true, width: '190px' },
  { id: 'contact', label: 'CONTACT', sort: true, width: '190px' },
  { id: 'createdDate', label: 'DATE_CREATED', sort: true },
  { id: 'lastAccess', label: 'LAST_ACCESS', sort: true },
  { id: 'storeCount', label: 'STORES', sort: true, align: 'right' },
  { id: 'productCount', label: 'PRODUCTS', sort: true, align: 'right' },
  { id: 'status', label: 'STATUS', align: 'center' },
  { id: 'actions', label: 'EDIT', align: 'center' }
];

export const storeTableHeaders: HeadCell[] = [
  { id: 'storeName', label: 'STORE_NAME', sort: true, width: '190px' },
  { id: 'supplierName', label: 'SUPPLIER_NAME', sort: true, width: '190px' },
  { id: 'contact', label: 'STORE_CONTACT', sort: true, width: '190px' },
  { id: 'createdDate', label: 'DATE_CREATED', sort: true },
  { id: 'lastOrderDate', label: 'LAST_ORDER_DATE', sort: true },
  { id: 'totalOrders', label: 'TOTAL_ORDERS', sort: true, align: 'right' },
  { id: 'totalOrderValue', label: 'TOTAL_ORDER_VALUE', sort: true, align: 'right' },
  { id: 'status', label: 'STATUS', sort: true }
];
